import axios from "axios";
import Cookies from "js-cookie";
import router from "@/router";
import qs from "qs";
import isPlainObject from "lodash/isPlainObject";
import { sign, encrypt, genNonce } from "@/cypher";

// ============ axios 实例 ============
const http = axios.create({
  baseURL: window.SITE_CONFIG["apiURL"],
  timeout: 1000 * 180,
  withCredentials: true,
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = Cookies.get("language") || "zh-CN";
    config.headers["token"] = Cookies.get("webToken") || "";

    var defaults = {};

    if (config.method === "get") {
      config.params = {
        ...config.params,
        ...{ _t: new Date().getTime() },
      };
    }

    if (isPlainObject(config.params)) {
      config.params = {
        ...defaults,
        ...config.params,
      };
    }

    if (isPlainObject(config.data)) {
      config.data = {
        ...defaults,
        ...config.data,
      };
      if (/^application\/x-www-form-urlencoded/.test(config.headers["content-type"])) {
        config.data = qs.stringify(config.data);
      }
    }

    // ============ POST 加密 + 签名 ============
    // 约定：请求头 X-Encrypt: true 时，对请求体加密并生成 sign/nonce
    if (config.method === "post") {
      const isFormData = typeof FormData !== "undefined" && config.data instanceof FormData;
      const isBlob = typeof Blob !== "undefined" && config.data instanceof Blob;

      if (!isFormData && !isBlob && config.data !== undefined && config.data !== null) {
        // 1. 加密请求体
        const plain = typeof config.data === "string" ? config.data : JSON.stringify(config.data);
        const encryptStr = encrypt(plain);

        // 2. 生成 nonce + sign
        const nonce = genNonce();
        const signStr = sign(nonce, encryptStr);

        // 3. 放入 header，appkey 不再下发
        // config.headers['X-Encrypt'] = 'true'
        config.headers["nonce"] = nonce;
        config.headers["sign"] = signStr;

        // 4. 请求体替换为密文
        config.data = encryptStr;
        // config.headers['Content-Type'] = 'text/plain; charset=UTF-8'
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// ============ token 相关 ============
http.getToken = () => Cookies.get("webToken");
http.setToken = (token) => Cookies.set("webToken", token);
http.removeToken = () => Cookies.remove("webToken");

/**
 * 请求地址处理
 */
http.adornUrl = (actionName) => {
  return window.SITE_CONFIG["apiURL"] + "/api/" + actionName;
};

/**
 * get 请求参数处理
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    t: new Date().getTime(),
  };
  return openDefultParams ? merge(defaults, params) : params;
};

/**
 * post 请求数据处理
 */
http.adornData = (data = {}, openDefultdata = true, contentType = "json") => {
  var defaults = {
    t: new Date().getTime(),
  };
  data = openDefultdata ? merge(defaults, data) : data;
  return contentType === "json" ? JSON.stringify(data) : qs.stringify(data);
};

/**
 * 响应拦截
 */
http.interceptors.response.use(
  (response) => {
    if (response.data && response.data.code === 401) {
      console.log("tz,", response.data);
      window.open(window.SITE_CONFIG["loginURL"], "_self");
      return Promise.reject(response.data.msg);
    }
    return response;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  },
);

export default http;
